import axios from "axios";

export default {
    namespaced: true,
    state: {
        bincardlist:[],
      
    },
    getters:{
        bincardlist(state){
            return state.bincardlist
        },
       
    },  
    mutations:{
        SET_BINCARD_LIST (state, payload) {
            state.bincardlist = payload
        },
      
    },
    actions:{
       async getAllBinData(context,param){
        const response = await axios.get('/api/bincards',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){
                context.commit('SET_BINCARD_LIST',response.data.data)
            }
       },
    
    }
}